import { Outlet, Route } from 'react-router-dom';
import { Navigate } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import queryString from 'query-string';
import { LayoutCabinet } from 'components/layout';
import CabinetPage from '../pages/cabinet';
import {
  AccountsPage,
  AddAccountPage,
  AddCreativeTextPage,
  AddFlowPage,
  AddGoToTestPage,
  ScalingHistoryPage,
  ScalingHistoryByAdsPage,
  ScalingHistoryByPacksPage,
  TestingHistoryPage,
  TestingHistoryByAdsPage,
  TestingHistoryByHypothesisPage,
  CreativeTextsPageFB,
  EditCreativeTextPage,
  EditGoToTestPage,
  FacebookSheetsPage,
  FlowsPage,
  GoToTestPage,
  OverviewDashboardPage,
  PartnershipsPage,
} from '../pages/cabinet/facebook';
import { ProtectedRoute } from 'features/login';
import EditFlowPage from '../pages/cabinet/facebook/EditFlowPage';
import EditAccountPage from '../pages/cabinet/facebook/EditAccountPage';
import AddFacebookPagePage from '../pages/cabinet/facebook/AddFacebookPagePage';
import EditFacebookPagesPage from '../pages/cabinet/facebook/EditFacebookPagesPage';
import UsersPage from '../pages/cabinet/facebook/UsersPage';
import EditUserPage from '../pages/cabinet/facebook/EditUserPage';
import {
  AddCreativeTextPageTT,
  AddFlowPageTT,
  AddGoToTestPageTT,
  AdsHistoryPageTT,
  CreativeTextsPageTT,
  EditCreativeTextPageTT,
  EditFlowPageTT,
  EditGoToTestPageTT,
  FlowsPageTT,
  GoToTestPageTT,
} from '../pages/cabinet/tiktok';
import { UploadCreativesPageX } from '../pages/cabinet/twitter';

const CabinetRouter = (
  <Route path="/cabinet">
    <Route index element={<Navigate to="overview" />} />
    <Route
      path={''}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="Facebook Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >
      <Route path={''} element={<Navigate to="overview" />} />
      <Route index path={'overview'} element={<OverviewDashboardPage />} />
    </Route>
    <Route
      path={'facebook'}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="Facebook Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >
      <Route path={''} element={<Navigate to="scaling-history" />} />
      <Route path={'ads-history'} element={<Navigate to="../scaling-history" replace />} />
      <Route path={'scaling-history'} element={<ScalingHistoryPage />}>
        <Route index element={<Navigate to="by-ads" replace />} />
        <Route path={'by-ads'} element={<ScalingHistoryByAdsPage />} />
        <Route path={'by-packs'} element={<ScalingHistoryByPacksPage />} />
        <Route path={'*'} element={<Navigate to="by-ads" replace />} />
      </Route>
      <Route path={'testing-history'} element={<TestingHistoryPage />}>
        <Route index element={<Navigate to="by-ads" replace />} />
        <Route path={'by-ads'} element={<TestingHistoryByAdsPage />} />
        <Route path={'by-hypothesis'} element={<TestingHistoryByHypothesisPage />} />
        <Route path={'*'} element={<Navigate to="by-ads" replace />} />
      </Route>
      <Route path={'flows'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={<FlowsPage />}
        />
        <Route
          path={'add'}
          element={<AddFlowPage />}
        />
        <Route
          path={':flowId'}
          element={<EditFlowPage />}
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'creative-texts'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={<CreativeTextsPageFB />}
        />
        <Route
          path={'add'}
          element={<AddCreativeTextPage />}
        />
        <Route
          path={':textId'}
          element={<EditCreativeTextPage />}
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'accounts'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={<AccountsPage />}
        />
        <Route
          path={'add'}
          element={<AddAccountPage />}
        />
        <Route
          path={':accountId'}
          element={<EditAccountPage />}
        />
      </Route>
      <Route path={'facebook-pages'} element={<Outlet />}>
        <Route
          path={''}
          element={<FacebookSheetsPage />}
        />
        <Route
          path={'add'}
          element={<AddFacebookPagePage />}
        />
        <Route
          path={':facebookId'}
          element={<EditFacebookPagesPage />}
        />
      </Route>
      <Route path={'partnerships'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={<PartnershipsPage />}
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'go-to-test'} element={<Outlet />}>
        <Route
          path={''}
          element={<GoToTestPage />}
        />
        <Route
          path={'add'}
          element={<AddGoToTestPage />}
        />
        <Route
          path={':goToTestId'}
          element={<EditGoToTestPage />}
        />
      </Route>
      <Route path={'users'} element={<Outlet />}>
        <Route
          path={''}
          element={<UsersPage />}
        />
        <Route
          path={':userId'}
          element={<EditUserPage />}
        />
      </Route>
    </Route>

    <Route
      path={'tiktok'}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="TikTok Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >

      <Route path={''} element={<Navigate to="creative-texts" />} />
      <Route path={'ads-history'} element={<AdsHistoryPageTT />} />
      <Route path={'creative-texts'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/creative-texts">
              <CreativeTextsPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/creative-texts">
              <AddCreativeTextPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={':textId'}
          element={
            <ProtectedRoute path="/creative-texts">
              <EditCreativeTextPageTT />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'flows'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/flows">
              <FlowsPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/flows">
              <AddFlowPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={':flowId'}
          element={
            <ProtectedRoute path="/flows">
              <EditFlowPageTT />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'go-to-test'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/go-to-test">
              <GoToTestPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/go-to-test">
              <AddGoToTestPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={':goToTestId'}
          element={
            <ProtectedRoute path="/go-to-test">
              <EditGoToTestPageTT />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
    </Route>
    <Route
      path={'twitter'}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="X Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >
      <Route path={''} element={<Navigate to="ads-replacement" />} />
      <Route
        path={'ads-replacement'}
        element={
          <ProtectedRoute path="/ads-replacement">
            <UploadCreativesPageX />
          </ProtectedRoute>
        }
      />
      <Route path={'*'} element={<Navigate to="ads-replacement" />} />
    </Route>
  </Route>
);

export default CabinetRouter;